'use client';

import { Grid, Stack, Typography } from '@mui/material';
import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';

import Social from '@/components/bases/Social';
import type { SocialItem } from '@/global/types/common.type';

const footerLinks = [
  {
    label: 'All Rights Reserved',
  },
  {
    label: 'Terms & Conditions',
    href: 'https://lfg.inc/terms',
    target: '_blank',
  },
  {
    label: 'Privacy Policy',
    href: 'https://lfg.inc/privacy',
    target: '_blank',
  },
  {
    label: 'Support Center',
    href: 'https://support.lfg.inc',
    target: '_blank',
  },
  {
    label: 'Core Dashboard',
    href: 'https://node.lfg.inc',
    target: '_blank',
  },
];

const Footer = () => {
  const [socials] = useState<SocialItem[]>([
    { href: 'https://x.com/LFGincorporated', src: '/icons/socials/x.svg', alt: 'x' },
    { href: 'https://discord.gg/PjTfVJh4Wr', src: '/icons/socials/discord.svg', alt: 'discord' },
    { href: 'https://www.linkedin.com/company/lfg-incorporated/', src: '/icons/socials/linkedin.svg', alt: 'linkedin' },
    { href: 'https://www.youtube.com/@lfginc', src: '/icons/socials/youtube.svg', alt: 'youtube' },
  ]);

  return (
    <Stack
      paddingY={3}
      width={'100%'}
      component={'footer'}
      alignItems={'center'}
      justifyContent={'center'}
      sx={{ borderTop: '1px solid #FFFFFF0F' }}>
      <Stack
        gap={{ xs: 3, sm: 2 }}
        width={'min(1344px, 100%)'}
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={'center'}
        justifyContent={'space-between'}
        paddingX={{ lg: 0, xs: 2 }}>
        <Stack
          width={{ xs: '100%', sm: 'fit-content' }}
          gap={4}
          alignItems={'center'}
          direction={{ xs: 'column', sm: 'row' }}
          sx={{ width: { xs: '100%', sm: 'auto' } }}>
          <Grid container spacing={2} sx={{ width: { xs: '100%', sm: 'auto' } }}>
            {footerLinks.map(link => {
              if (!link.href) {
                return (
                  <Grid item xs={6} sm='auto' key={link.label}>
                    <Typography
                      variant={'bodyMedium'}
                      color={'#FFFFFF59'}
                      textTransform={'capitalize'}
                      noWrap
                      fontSize={{ xs: '12px', sm: '14px' }}>
                      {link.label}
                    </Typography>
                  </Grid>
                );
              }
              return (
                <Grid item xs={6} sm='auto' key={link.label}>
                  <Link href={link.href} target={link.target}>
                    <Typography
                      variant={'bodyMedium'}
                      color={'#FFFFFF59'}
                      textTransform={'capitalize'}
                      noWrap
                      fontSize={{ xs: '12px', sm: '14px' }}>
                      {link.label}
                    </Typography>
                  </Link>
                </Grid>
              );
            })}
          </Grid>
        </Stack>
        <Stack
          width={{ xs: '100%', sm: 'fit-content' }}
          gap={5}
          alignItems={'center'}
          direction={'row'}
          justifyContent={{ xs: 'space-between', sm: 'flex-end' }}>
          <Link href={'https://lfg.inc'} target={'_blank'} style={{ lineHeight: 0 }}>
            <Image
              alt={'lfg'}
              height={32}
              width={162}
              src={'/icons/LFGLogo.svg'}
              className={'w-[151px] h-[30px] sm:w-[162px] sm:h-[32px]'}
            />
          </Link>
          <Stack gap={2} alignItems={'center'} direction={'row'}>
            {socials.map(social => (
              <Social key={social.alt} {...social} className={'w-[24px] h-[24px] sm:w-[32px] sm:h-[32px]'} />
            ))}
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Footer;
